export default __webpack_public_path__ + "static/media/product-image-hover-19.ec86be4f.jpg";